import { render, staticRenderFns } from "./JciProgramCreate.vue?vue&type=template&id=d74ff768&scoped=true"
import script from "./JciProgramCreate.vue?vue&type=script&lang=js"
export * from "./JciProgramCreate.vue?vue&type=script&lang=js"
import style0 from "./JciProgramCreate.vue?vue&type=style&index=0&id=d74ff768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74ff768",
  null
  
)

export default component.exports